'use strict';

import { Entity } from '../Entity';

export class IndEmail extends Entity {
  protected indEmailId;
  protected indId = '0';
  protected indEmailOwner;
  protected indEmailType;
  protected indEmailAddress;
  protected indEmailPref;
  protected indEmailDisc;
  protected indEmailOptOut;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indEmailId = data.indEmailId;
    this.indId = data.indId;
    this.indEmailOwner = data.indEmailOwner;
    this.indEmailType = data.indEmailType;
    this.indEmailAddress = data.indEmailAddress;
    this.indEmailPref = data.indEmailPref;
    this.indEmailDisc = data.indEmailDisc;
    this.indEmailOptOut = data.indEmailOptOut;
  }

  public getIndEmailId() {
    return this.indEmailId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndEmailOwner() {
    return this.indEmailOwner;
  }

  public getIndEmailType() {
    return this.indEmailType;
  }

  public setIndEmailType(indEmailType) {
    this.indEmailType = indEmailType;

    return this;
  }

  public getIndEmailAddress() {
    return this.indEmailAddress;
  }

  public setIndEmailAddress(indEmailAddress) {
    this.indEmailAddress = indEmailAddress;

    return this;
  }

  public getIndEmailPref() {
    return this.indEmailPref;
  }

  public getIndEmailDisc() {
    return this.indEmailDisc;
  }

  public getIndEmailOptOut() {
    return this.indEmailOptOut;
  }
}
